module.exports = __webpack_public_path__ + "img/pic01.54fee3f7.png";